import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.morph();
  }

  morph() {
    const getText = this.DOM.view.getAttribute('data-href');
    let morphText = getText.replace('[AT]', '@').replace('[DOT]', '.');
    let textVisible = morphText.replace('mailto:', '').replace('tel:', '');
    this.DOM.view.setAttribute('href', 'mailto:' + morphText);
    this.DOM.view.innerHTML = this.DOM.view.dataset.text;
  }
}
